import axiosInstance from "../Axios-Config/Axios-Config";
import { SETLANGUAGEDATA } from "../redux/features/TransalationData";
import Konsole from "../utils/konsole/Konsole";
import { Dispatch } from "redux";

async function LanguageApi(dispatch: Dispatch, store_id: string) {
  try {
    const storeId = sessionStorage.getItem("store-id" ) || store_id;
    const { data } = await axiosInstance.post(
      `menu/list/by/language?store_id=${storeId}`
    );
    dispatch(SETLANGUAGEDATA(Array.isArray(data.data) ? {} : data?.data));
  } catch (error: any) {
    Konsole.log("error", error);
  }
}
export default LanguageApi;
